import React, { useMemo } from 'react';

import classnames from 'classnames';

import SpriteIcon from 'components/uiLibrary/SpriteIcon';
import Typography from 'components/uiLibrary/Typography';

import { FILTER_AGGREGATION_SEARCH, PRODUCTIONS } from 'constants/endpointConstants';
import { AGGREGATION_TYPES, TP } from 'constants/index';
import { CASTING_SEARCH_CATEGORIES_KEYS } from 'constants/search';

import { getComposerFromCreators } from 'utils/composer';
import { useQuery } from 'utils/react-query';

import searchQueries from 'containers/Search/queries';

import { useTranslation } from 'src/i18n';

import classes from './CastingInput.module.scss';

const CastingInput = ({ setSelectedCategory, category, sinceYear, countries, workId, composer: selectedComposer }) => {
  const { t } = useTranslation('NS_CASTING_TOOL');

  const { data: fetchedWork } = useQuery(
    searchQueries.getSelectedOption({
      identifier: workId,
      endpoint: FILTER_AGGREGATION_SEARCH(PRODUCTIONS),
      queryParams: {
        work_id: workId,
        aggregation_type: AGGREGATION_TYPES.WORK,
      },
      queryConfig: {
        enabled: !!workId,
      },
    }),
  );
  const composer = useMemo(
    () => (selectedComposer?.id ? selectedComposer : getComposerFromCreators(fetchedWork?.creators)?.profile || {}),
    [fetchedWork?.creators, selectedComposer],
  );

  const selected = useMemo(() => {
    if (category.key === CASTING_SEARCH_CATEGORIES_KEYS.SINCE) {
      return !!sinceYear;
    }

    if (category.key === CASTING_SEARCH_CATEGORIES_KEYS.COUNTRIES) {
      return true;
    }

    if (category.key === CASTING_SEARCH_CATEGORIES_KEYS.WORKS) {
      return !!workId;
    }

    if (category.key === CASTING_SEARCH_CATEGORIES_KEYS.CREATORS) {
      return !!composer?.id;
    }

    return false;
  }, [category.key, sinceYear, workId, composer?.id]);

  const renderSelectedValue = () => {
    if (category.key === CASTING_SEARCH_CATEGORIES_KEYS.SINCE) {
      return (
        <Typography size="12" weight="medium">
          {sinceYear}
        </Typography>
      );
    }

    if (category.key === CASTING_SEARCH_CATEGORIES_KEYS.COUNTRIES) {
      return (
        <Typography size="12" weight="medium">
          {countries?.map(country => country.name).join(', ') || t(`${TP}.FN_ALL`)}
        </Typography>
      );
    }

    if (category.key === CASTING_SEARCH_CATEGORIES_KEYS.CREATORS) {
      return (
        <span className={classes.search__inputSelected_label}>
          <Typography size="12" weight="medium">
            {composer?.name || composer?.name}
          </Typography>
          {(composer?.name || composer?.name) && (
            <Typography size="10" color="quinary">
              {composer?.profession?.name || composer?.profession?.name || t(`${TP}.m_COMPOSER`)}
            </Typography>
          )}
        </span>
      );
    }

    if (category.key === CASTING_SEARCH_CATEGORIES_KEYS.WORKS) {
      const composerProfile = getComposerFromCreators(fetchedWork?.creators);

      return (
        <span className={classes.search__inputSelected_label}>
          <Typography size="12" weight="medium">
            {fetchedWork?.name}
            {fetchedWork?.original_name !== fetchedWork?.name && (
              <Typography size="10"> ({fetchedWork?.original_name})</Typography>
            )}
          </Typography>
          <Typography size="10" color="quinary">
            {composerProfile?.profile?.name}{' '}
            {fetchedWork?.workTypes?.[0]?.name ? `| ${fetchedWork?.workTypes?.[0]?.name}` : ''}
          </Typography>
        </span>
      );
    }

    return null;
  };

  return (
    <div
      className={classnames(classes.search__input, {
        [classes.search__inputSelected]: selected,
      })}
      onClick={() => setSelectedCategory(category)}
    >
      {!selected && (
        <span className={classes.search__searchIcon}>
          <SpriteIcon icon="search" size="16" />
        </span>
      )}
      {renderSelectedValue()}
      {selected && <SpriteIcon icon="keyboard_arrow_down" size="16" />}
    </div>
  );
};

export default CastingInput;
